import { asText } from '@prismicio/helpers';

export function hasBanner(bannerField = []) {
  return asText(bannerField || []).length > 0;
}
